var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"el-spinner",class:{
    [`el-spinner--size-${_vm.computedSize}`]: _vm.size,
    [`el-spinner--color-${_vm.color}`]: _vm.color
  }})
}
var staticRenderFns = []

export { render, staticRenderFns }